import React from 'react'

const EKycIcon = ({color:stroke="#000"}) => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.6665 19.25V17.4167C14.6665 16.4442 14.2802 15.5116 13.5926 14.8239C12.9049 14.1363 11.9723 13.75 10.9998 13.75H4.58317C3.61071 13.75 2.67808 14.1363 1.99045 14.8239C1.30281 15.5116 0.916504 16.4442 0.916504 17.4167V19.25" stroke={stroke} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.79167 10.0833C9.81671 10.0833 11.4583 8.44171 11.4583 6.41667C11.4583 4.39162 9.81671 2.75 7.79167 2.75C5.76662 2.75 4.125 4.39162 4.125 6.41667C4.125 8.44171 5.76662 10.0833 7.79167 10.0833Z" stroke={stroke} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15.5835 10.0833L17.4168 11.9167L21.0835 8.25" stroke={stroke} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
  )
}

export default EKycIcon